// Order-insensitive equality of two id lists; a duplicate on one side counts as a difference.
export const sameSet = <T>(a: T[], b: T[]): boolean => {
  const setA = new Set(a);
  const setB = new Set(b);
  return (
    setA.size === setB.size &&
    setA.size === a.length &&
    setB.size === b.length &&
    a.every((item) => setB.has(item))
  );
};
